function formatAmount(value: number): string {
  const [intPart, decPart] = value.toFixed(2).split('.');
  const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return decPart === '00' ? intFormatted : `${intFormatted},${decPart}`;
}

export class PillarSelector {
  private root: HTMLElement;
  private checkboxes: HTMLInputElement[];
  private totalEl: HTMLElement | null;
  private submitBtn: HTMLButtonElement | null;
  private checkoutBase: string;

  constructor(root: HTMLElement) {
    this.root = root;
    this.checkboxes = Array.from(
      root.querySelectorAll('[data-pillar-checkbox]')
    );
    this.totalEl = root.querySelector('[data-pillar-total]');
    this.submitBtn = root.querySelector('[data-pillar-submit]');
    this.checkoutBase = root.dataset.pillarCheckoutBase || '';

    this._init();
  }

  private _init() {
    this.checkboxes.forEach(checkbox => {
      if (checkbox.disabled) {
        return;
      }

      checkbox.addEventListener('change', () => this._update());
    });

    this.submitBtn?.addEventListener('click', () => this._submit());

    this._update();
  }

  private _checkedCheckboxes(): HTMLInputElement[] {
    return this.checkboxes.filter(
      checkbox => !checkbox.disabled && checkbox.checked
    );
  }

  private _update() {
    const checked = this._checkedCheckboxes();

    this.checkboxes.forEach(checkbox => {
      const item = checkbox.closest<HTMLElement>('[data-pillar-item]');
      item?.classList.toggle('pillar-selector__item--checked', checkbox.checked);
    });

    const totalHt = checked.reduce(
      (sum, checkbox) => sum + parseFloat(checkbox.dataset.pillarPriceHt || '0'),
      0
    );
    const totalTtc = checked.reduce(
      (sum, checkbox) => sum + parseFloat(checkbox.dataset.pillarPriceTtc || '0'),
      0
    );

    if (this.totalEl) {
      const htEl = this.totalEl.querySelector('[data-pillar-total-ht]');
      const ttcEl = this.totalEl.querySelector('[data-pillar-total-ttc]');

      if (htEl) {
        htEl.textContent = `${formatAmount(totalHt)} € HT`;
      }
      if (ttcEl) {
        ttcEl.textContent = `${formatAmount(totalTtc)} € TTC`;
      }

      this.totalEl.classList.toggle(
        'pillar-selector__total--visible',
        checked.length > 0
      );
    }

    if (this.submitBtn) {
      this.submitBtn.disabled = checked.length === 0;
    }
  }

  private _submit() {
    if (!this.submitBtn || this.submitBtn.disabled || !this.checkoutBase) {
      return;
    }

    const ids = this._checkedCheckboxes().map(
      checkbox => checkbox.dataset.pillarId
    );
    const separator = this.checkoutBase.includes('?') ? '&' : '?';

    window.location.href = `${this.checkoutBase}${separator}piliers=${ids.join(',')}`;
  }
}

document
  .querySelectorAll<HTMLElement>('[data-pillar-selector]')
  .forEach(root => new PillarSelector(root));
